import { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";

import { Container } from "@mui/material";
import { PerformRequest, usePerformRequest } from "../../lib/usePerformRequest";
import { NonPaginatedResponse } from "../../lib/Responses";
import { useForm } from "@mantine/form";
import { Endpoints } from "../../lib/Endpoints";
import { DefaultErrorNotification, DefaultSuccessNotification } from "../../lib/Methods";
import { Button, Card, Image, Paper, PasswordInput, Text, TextInput } from "@mantine/core";
import { Colors, Images } from "../../lib/Data";

import "./styles.scss";
import MegaLoader from "../../components/MegaLoader";
import AnimateOnLoad from "../../components/AnimateOnLoad";
const Onboard: React.FC = () => {
  const { adminID } = useParams();

  const { isLoading: isLoadingOnboardingLinkStatus, status: onboardingLinkStatus } = usePerformRequest({
    method: "GET",
    route: Endpoints.GetCompleteAdminOnboard(adminID as string),
  });

  const [isLinkExpired, setLinkExpired] = useState<boolean>(false);
  useEffect(() => {
    if (onboardingLinkStatus) {
      if (onboardingLinkStatus !== 200) {
        setLinkExpired(true);
      } else {
        setLinkExpired(false);
      }
    }
  }, [onboardingLinkStatus]);
  const navigate = useNavigate();
  const passwordForm = useForm({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validate: {
      password: (value) => (value && value.length >= 6 ? null : "At least SIX characters"),
      confirmPassword: (value, values) => (value && value.length >= 6 && values.password === value ? null : "Passwords do not match!"),
    },
  });

  const [isLoading, setLoading] = useState<boolean>(false);
  const UpdatePassword = async () => {
    const { hasErrors } = passwordForm.validate();
    if (!hasErrors) {
      const { password } = passwordForm.values;
      setLoading(true);
      const r = await PerformRequest({
        method: "PATCH",
        route: Endpoints.GetCompleteAdminOnboard(adminID as string),
        callback: () => {
          setLoading(false);
        },
        data: {
          password,
        },
      });
      if (r) {
        if (r.status === 200) {
          DefaultSuccessNotification("Your password has been updated! Please login to continue");
          navigate("/login");
        } else if (r.status === 403) {
          DefaultErrorNotification(r.message);
        }
      }
      setLoading(false);
    }
  };
  return (
    <AnimateOnLoad>
      <div className="onboard-container flex-col align-center justify-center">
        {isLoadingOnboardingLinkStatus ? (
          <MegaLoader />
        ) : (
          <>
            {isLinkExpired ? (
              <>
                <Card shadow="sm" padding="sm" w={350}>
                  <Card.Section>
                    <Image src={Images.ForgotPasswordImage} h={200} alt="No way!" />
                  </Card.Section>

                  <Text fw={500} size="lg" mt="md">
                    Expired or Invalid Link
                  </Text>

                  <Text my={15} c="dimmed" size="sm">
                    This link is expired or invalid. Please request another one from the Admin
                  </Text>

                  <Button
                    onClick={() => {
                      navigate("/login");
                    }}
                    radius="50px"
                    color={Colors.GreenPrimary}
                  >
                    Back to Login
                  </Button>
                </Card>
              </>
            ) : (
              <>
                <Text ta="center" className="title">
                  Complete Profile!
                </Text>
                <Text size="xs">You must update your password</Text>

                <div className="form">
                  <Paper withBorder shadow="md" p={30} mt={30} radius="md">
                    <PasswordInput
                      label="Password"
                      placeholder="Your password"
                      required
                      mt="md"
                      {...passwordForm.getInputProps("password")}
                      spellCheck={false}
                    />
                    <PasswordInput
                      label="Confirm Password"
                      placeholder="Enter password again"
                      required
                      mt="md"
                      {...passwordForm.getInputProps("confirmPassword")}
                      spellCheck={false}
                    />

                    <Button className="btn" color={Colors.GreenPrimary} onClick={UpdatePassword} fullWidth mt="xl" loading={isLoading}>
                      Update Password
                    </Button>
                  </Paper>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </AnimateOnLoad>
  );
};

export default Onboard;
